import React from "react"

function Sun({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.0194 23.4071C21.2158 23.4071 23.8069 20.816 23.8069 17.6196C23.8069 14.4232 21.2158 11.8321 18.0194 11.8321C14.823 11.8321 12.2319 14.4232 12.2319 17.6196C12.2319 20.816 14.823 23.4071 18.0194 23.4071Z"
        stroke="#003E4C"
        strokeWidth="0.996379"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0182 10.4862V7.67383"
        stroke="#003E4C"
        strokeWidth="0.732074"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2206 17.974L29.033 17.9751"
        stroke="#003E4C"
        strokeWidth="0.77367"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0126 25.5133L18.0103 28.3257"
        stroke="#003E4C"
        strokeWidth="0.732075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81238 17.9633L7.00003 17.96"
        stroke="#003E4C"
        strokeWidth="0.77367"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9855 11.3748L23.4352 8.96484"
        stroke="#003E4C"
        strokeWidth="0.589979"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1413 24.4888L23.6446 26.8656"
        stroke="#003E4C"
        strokeWidth="0.550597"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8256 21.5962L8.31451 22.8625"
        stroke="#003E4C"
        strokeWidth="0.582277"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8579 24.4692L12.3426 26.8384"
        stroke="#003E4C"
        strokeWidth="0.58879"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1018 21.7764L27.5798 23.1062"
        stroke="#003E4C"
        strokeWidth="0.546514"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0213 14.0429L27.4739 12.6665"
        stroke="#003E4C"
        strokeWidth="0.584186"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9169 11.4423L12.4213 9.06055"
        stroke="#003E4C"
        strokeWidth="0.550735"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0311 14.0202L8.58282 12.6362"
        stroke="#003E4C"
        strokeWidth="0.547415"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Sun
